<script>
    import {ready, url} from "@sveltech/routify";
    import {apiFetch} from '../../../apiFetch';

    export let organizationId;

    const fetchOrganizations = (async () => {
        const response = await apiFetch('/organizationId/' + organizationId);
        return await response.json()
    })()
</script>

<h2>Organization </h2>

{#await fetchOrganizations}
    <p>...waiting</p>
{:then data}
    <h2>{data.organization.name}</h2>

    {#each data.campaign.campaignItem as { id, name, from, to }}
        <h3>{id}</h3>
        <h3>{name}</h3>
        <hr>
    {/each}

{:catch error}
    {@debug error}
    <p>An error occurred!</p>
{/await}